import get from './get';
import post from './post';
import patch from './patch';

export default {
  get,
  post,
  patch,
};
